import {
  LOAD_PROVINE_NEW,
  SAVE_WARD_NEW,
  CHANGE_WARD_NEW,
  CLEAR_ALL_PROVINE_NEW,
} from "../action/Types";

import cityJson from "../json/provinces_new.json";
let city = [];
for (let val of cityJson) {
  city.push({ cityCode: val.code, cityName: val.name });
}

const initialState = {
  provineLoading: true,
  type: "tinhThanhMoi",
  city: city,
  ward: [],
};

const ProvineNew = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHANGE_WARD_NEW:
      return {
        ...state,
        choicedWardCode: payload.choicedWardCode,
        choicedward: payload.choicedward,
      };
    case LOAD_PROVINE_NEW:
      return {
        ...state,
        choicedWardCode: payload.choicedWardCode,
        choicedCityCode: payload.choicedCityCode,
        choicedcity: payload.choicedCity,
        choicedward: payload.choicedWard,
      };
    case SAVE_WARD_NEW:
      return { ...state, ward: payload };
    case CLEAR_ALL_PROVINE_NEW:
      return { provineLoading: true, city: city, ward: [] };
    default:
      return state;
  }
};

export default ProvineNew;
